import { Direction } from 'src/generated/brezavta/requests/types.gen'

export function getDirectionIcon(direction: Direction): string {
    switch (direction) {
        case 'LEFT': return '←'
        case 'RIGHT': return '→'
        case 'SLIGHTLY_LEFT': return '↰'
        case 'SLIGHTLY_RIGHT': return '↱'
        case 'HARD_LEFT': return '⇚'
        case 'HARD_RIGHT': return '⇛'
        case 'UTURN_LEFT': return '↺'
        case 'UTURN_RIGHT': return '↺'
        case 'CONTINUE': return '↑'
        case 'DEPART': return '↑'
        case 'ARRIVE': return '↓'
        default: return '→'
    }
}

export function getDirectionLabel(direction: Direction, t: (key: string) => string): string {
    switch (direction) {
        case 'LEFT': return t('Turn left')
        case 'RIGHT': return t('Turn right')
        case 'SLIGHTLY_LEFT': return t('Slight left')
        case 'SLIGHTLY_RIGHT': return t('Slight right')
        case 'HARD_LEFT': return t('Hard left')
        case 'HARD_RIGHT': return t('Hard right')
        case 'UTURN_LEFT': return t('Make a U-turn')
        case 'UTURN_RIGHT': return t('Make a U-turn')
        case 'CONTINUE': return t('Continue straight')
        case 'DEPART': return t('Continue straight')
        case 'ARRIVE': return t('Continue straight')
        default: return t('Continue straight')
    }
}

export function isSignificantDirection(direction: Direction): boolean {
    return [
        'LEFT',
        'RIGHT',
        'SLIGHTLY_LEFT',
        'SLIGHTLY_RIGHT',
        'HARD_LEFT',
        'HARD_RIGHT',
        'UTURN_LEFT',
        'UTURN_RIGHT',
    ].includes(direction)
}

export function formatStepDistance(meters: number): string {
    if (meters < 1000) {
        return `${Math.round(meters)}m`
    }
    return `${(meters / 1000).toFixed(1)}km`
}

export function formatStepDistanceForSpeech(meters: number): string {
    if (meters < 1000) {
        return `${Math.round(meters)} meters`
    }
    return `${(meters / 1000).toFixed(1)} kilometers`
}

export function getTransitModeLabel(mode: string): string {
    const modes: Record<string, string> = {
        BUS: 'bus',
        TRAM: 'tram',
        SUBWAY: 'subway',
        RAIL: 'train',
        FERRY: 'ferry',
        CABLE_CAR: 'cable car',
        GONDOLA: 'gondola',
        FUNICULAR: 'funicular',
        TRANSIT: 'transit',
    }
    return modes[mode] ?? mode.toLowerCase()
}
